export const URL= 'app.calendarbudget.com' //this get replaced by build.xml during deployment in Eclipse
export const APP_URL = `https://${URL}/`
export const KEY_LOGIN_URL = `${APP_URL}log-in/`
export const KEY_FORGOT_PASSWORD = `${APP_URL}ForgotPassword`
export const KEY_LOGIN = `${APP_URL}Login`
export const KEY_SIGNUP = `${APP_URL}Register`
export const KEY_CALENDAR = `${APP_URL}Calendar/`
export const KEY_TERMS_AND_CONDITIONS = `https://calendarbudget.com/terms-and-conditions/`
export const KEY_PRIVACY_POLICY = `https://calendarbudget.com/security-and-privacy/`
